import { AnyAction } from 'redux';
import actionTypes from '../types/leftSideBarTypes';

const initialState = {
  chartHeader: '',
  requestPayload: null,
  chartData: {},
  reimbursementChartDetails: {},
  creditData: {},
};

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.SIDEBAR_HEADER:
      return {
        ...state,
        chartHeader: action.payload,
      };
    case actionTypes.SIDEBAR_REQUEST_PAYLOAD:
      return {
        ...state,
        requestPayload: action.payload,
      };
    case actionTypes.SIDEBAR_DATA:
      return {
        ...state,
        chartData: action.payload,
      };

    case actionTypes.FETCH_REIMBURSEMENT_SUCCESS:
      return {
        ...state,
        reimbursementChartDetails: action.payload,
      };

    case actionTypes.FETCH_PROVIDER_CREDITS_SUCCESS:
      return {
        ...state,
        creditData: action.payload,
      };

    default: return state;
  }
};

export { reducer as sideBarReducer };
